import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { loading, validateRuleData, enumData } from '@/decorators';

var AmazonModalForm = function (_super) {
  __extends(AmazonModalForm, _super);

  function AmazonModalForm() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.formDataRule = {};
    _this.formData = _this.initFormData();
    _this.loading = false;
    _this.labelCol = {
      span: 6
    };
    _this.wrapperCol = {
      span: 16
    };
    _this.smazonSiteEnum = [];
    return _this;
  }

  Object.defineProperty(AmazonModalForm.prototype, "isAuthAction", {
    get: function get() {
      return !!this.data.id;
    },
    enumerable: false,
    configurable: true
  });

  AmazonModalForm.prototype.validateFormDataRule = function (validateData) {
    this.formDataRule = this.$util.mergeValidate({}, validateData);
  };

  AmazonModalForm.prototype.onVisibleChange = function (value) {
    if (value) {
      this.formData = {
        id: this.data.id,
        account_name: this.data.account_name,
        platform_user_name: this.data.platform_user_name,
        site: this.data.site
      };
    } else {
      this.formData = this.initFormData();
      var com = this.$refs.formDataRef;
      com && com.resetFields();
    }
  };

  AmazonModalForm.prototype.initFormData = function () {
    return {
      id: undefined,
      site: '',
      account_name: '',
      platform_user_name: ''
    };
  };

  AmazonModalForm.prototype.handleOk = function () {
    var _this = this;

    var com = this.$refs.formDataRef;
    com.validate(function (valid) {
      return __awaiter(_this, void 0, Promise, function () {
        var postData, requestName, win, _a, code, data, message, e_1;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (!valid) {
                return [2];
              }

              postData = Object.assign({}, this.formData);

              if (this.isAuthAction) {
                requestName = this.$api.fbaReturnAccount.reAuthAccount;
                postData = {
                  id: postData.id
                };
              } else {
                requestName = this.$api.fbaReturnAccount.addAccount;
              }

              win = window.open("/loading");
              _b.label = 1;

            case 1:
              _b.trys.push([1, 3,, 4]);

              return [4, requestName(postData)];

            case 2:
              _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

              if (code === 0) {
                this.$message.success(this.t('操作成功'));
                this.formData = this.initFormData();
                this.visible = false;
                this.onSuccess();

                if (data && data.url) {
                  win && (win.location.href = data.url);
                  return [2];
                }
              } else {
                this.$message.error(message);
              }

              win === null || win === void 0 ? void 0 : win.close();
              return [3, 4];

            case 3:
              e_1 = _b.sent();
              win === null || win === void 0 ? void 0 : win.close();
              return [3, 4];

            case 4:
              return [2];
          }
        });
      });
    });
  };

  __decorate([Prop({
    type: Object,
    "default": function _default() {
      return {};
    }
  })], AmazonModalForm.prototype, "data", void 0);

  __decorate([Prop({
    type: Function,
    "default": null
  })], AmazonModalForm.prototype, "onSuccess", void 0);

  __decorate([enumData('Platform/AmazonSiteEnum')], AmazonModalForm.prototype, "smazonSiteEnum", void 0);

  __decorate([validateRuleData('/api/v1/order/fba_return_account/add')], AmazonModalForm.prototype, "validateFormDataRule", null);

  __decorate([Watch('visible')], AmazonModalForm.prototype, "onVisibleChange", null);

  __decorate([loading('loading')], AmazonModalForm.prototype, "handleOk", null);

  AmazonModalForm = __decorate([Component], AmazonModalForm);
  return AmazonModalForm;
}(Vue);

export default AmazonModalForm;